module.exports = __webpack_public_path__ + "img/12.73ebd82f.png";